import { TransactionSummaryResponse } from '@app/finxone-web-frontend/app/lib/services/chart-service/chart.type';
import { ChartDataContext, ChartDateRange } from '@app/finxone-web-frontend/app/lib/utils/chart.utils';
import dayjs from 'dayjs';
import { Observable, of } from 'rxjs';

export class MockChartService {
  constructor() {}

  public getChartDataByContext(
    context: ChartDataContext,
    accountId: string,
    startDate: string,
    endDate: string,
    xAxisRange: ChartDateRange,
  ): Observable<TransactionSummaryResponse[] | any[]> {
    const type = xAxisRange === ChartDateRange.YEAR ? 'month' : 'day';
    switch (context) {
      case ChartDataContext.TOTAL_SPENDING:
        return this.getTotalPaymentSpent(accountId, startDate, endDate, type);

      default:
        return of([]);
    }
  }

  public getTotalPaymentSpent(id: string, fromDate: string, toDate: string, type: string) {
    switch (type) {
      case 'day':
        return of(this.getWeeklyData(fromDate, toDate));
      case 'month':
        return of(this.getYearlyData(fromDate, toDate));
      default:
        return of([]);
    }
  }

  private getWeeklyData(fromDate: string, toDate: string) {
    let start = dayjs(fromDate);
    const end = dayjs(toDate);
    const days = [];

    while (start.isBefore(end, 'day') || start.isSame(end, 'day')) {
      days.push({
        date: start.format('YYYY-MM-DD'),
        totalAmount: this.randomAmount(),
      });
      start = start.add(1, 'day');
    }
    return days;
  }

  private getYearlyData(fromDate: string, toDate: string) {
    let start = dayjs(fromDate).startOf('month');
    const end = dayjs(toDate).endOf('month');
    const months = [];

    while (start.isBefore(end, 'month') || start.isSame(end, 'month')) {
      months.push({
        date: start.format('YYYY-MM'),
        totalAmount: this.randomAmount(),
      });
      start = start.add(1, 'month');
    }
    return months;
  }

  private randomAmount() {
    return Math.round(Math.random() * 200); // Random value between 0 and 200
  }
}
